import { render, staticRenderFns } from "./SkuGroup.vue?vue&type=template&id=e659d734&"
import script from "./SkuGroup.vue?vue&type=script&lang=js&"
export * from "./SkuGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports